import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
import chatState from "../state/chat";
import ChatDrawer from "./ChatDrawer";
import { shouldUseChatDrawer } from "../utils/surface";
/**
 * "X made you a moderator of #channel."
 *
 * The stored data is ids only; the channel's name is read from the
 * notification's subject, which the notification list loads through the
 * channel's own visibility rules. The recipient is a member, so it is there.
 */
export default class ModeratorPromotedNotification extends Notification {
  icon() {
    return "fas fa-user-shield";
  }
  href() {
    const channelId = channelIdOf(this);
    return channelId ? app.route("chat.channel", {
      id: channelId
    }) : app.route("chat.index");
  }
  content() {
    return app.translator.trans("ramon-chat.forum.notifications.moderator_promoted", {
      username: fromName(this),
      channel: channelNameOf(this)
    });
  }
  excerpt() {
    return null;
  }
  onclick(e) {
    openChannelFromNotification(this, e);
  }
}

/** The notification's channel id, from its data or its subject. */
export function channelIdOf(notification) {
  var _ref, _data$channelId;
  const data = (_ref = notification.attrs.notification.content()) != null ? _ref : {};
  const subject = notification.attrs.notification.subject();
  const id = (_data$channelId = data.channelId) != null ? _data$channelId : subject ? Number(subject.id()) : null;
  return id ? Number(id) : null;
}

/** The channel's name as the reader sees it, or the chat's own title. */
export function channelNameOf(notification) {
  var _subject$displayName;
  const subject = notification.attrs.notification.subject();
  return (subject == null || (_subject$displayName = subject.displayName) == null ? void 0 : _subject$displayName.call(subject)) || app.translator.trans("ramon-chat.forum.nav.chat", {}, true);
}

/** Who sent the notification, or "Someone". */
export function fromName(notification) {
  const user = notification.attrs.notification.fromUser();
  return user ? user.displayName() : app.translator.trans("ramon-chat.forum.notifications.someone", {}, true);
}

/**
 * Opens the drawer when that is the reader's preference instead of following
 * the href, the same choice the header button makes.
 */
export function openChannelFromNotification(notification, e) {
  const channelId = channelIdOf(notification);
  if (!channelId || !shouldUseChatDrawer()) return;
  e.preventDefault();
  chatState.setActiveChannel(channelId);
  ChatDrawer.open();
}
flarum.reg.add('ramon-chat', 'forum/components/ModeratorPromotedNotification', ModeratorPromotedNotification);